module.exports = __webpack_public_path__ + "static/media/tmcf-pitch-cover.afe6fae6.jpg";